import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import MenuDesign from './components/MenuDesign'; // <-- make sure this is imported
import About from './components/About';
import Contact from './components/Contact';
import Gallery from './components/Gallery';
import './App.css';

function App() {
  const patternStyle = {
    backgroundImage: 'url(/repeating-pattern.png)',
    backgroundRepeat: 'repeat',
    backgroundSize: '100px 100px',
    backgroundPosition: 'center',
    position: 'relative'
  };

  return (
    <>
      <Navbar />

      <section id="home">
        <Home />
      </section>

      <section id="menu" style={patternStyle}>
        <div style={{ position: 'relative', zIndex: 2 }}>
          <MenuDesign />
        </div>
      </section>

      <section id="about">
        <About />
      </section>

      <section id="gallery" style={patternStyle}>
        <div style={{ position: 'relative', zIndex: 2 }}>
          <Gallery />
        </div>
      </section>

      <section id="contact">
        <Contact />
      </section>

      {/* Leave other sections for now, or update them later */}
    </>
  );
}

export default App;

